import * as yup from "yup";
import { BackendError } from "./BackendError";

const backendErrorSchema = yup.object().shape({
  status: yup.string().required(),
  errorCode: yup.string().required(),
  timeStamp: yup.string().required(),
});

export const isBackendError = (obj: unknown): obj is BackendError =>
  backendErrorSchema.isValidSync(obj);
